/* eslint-disable no-shadow */
/* eslint-disable no-sequences */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import { requiredFieldMessages, validateFieldMessages, customMessages } from './messages';

const store = window.readOnlyPurpleStore;
const FormValidator = () => ({
  formValidate(formId) {
    const requiredCamel = [];
    const form = [];
    let formData = [];
    const errorList = [];

    const snakeToCamel = (s) =>
      s.charAt(0).toUpperCase() + s.slice(1).replace(/(_\w)/g, (k) => k[1].toUpperCase());
    if (formId) {
      formData = document.getElementById(formId).elements;
    } else {
      formData = document.forms[0].elements;
    }
    Array.from(formData).reverse().filter((element) => (element.type !== 'button' && element.type !== 'submit')).forEach((element, index) => {
      form[element.id] = element.value;
      if (element.required) {
        requiredCamel[index] = snakeToCamel(element.id);
        if (!element.value) {
          errorList.push({ name: `${requiredCamel[index]}Exception`, message: requiredFieldMessages[element.id] });
          if (element.type === 'password' && element?.minLength !== 0) {
            errorList.push({ name: 'PasswordRequiredException', message: validateFieldMessages[element.id] });
          }
        }
      }
      // }

      if (element.id === 'phone_number' && element.value) {
        let phone_number = element.value.replace(/^\+1/, '');
        phone_number = `+1${phone_number.replace(/\s/g, '').replace(/[()+-]/g, '')}`;
        form[element.id] = phone_number;
        if (!this.checkIfValidPhoneFormat(phone_number)) {
          errorList.push({ name: 'InvalidParameterPhoneNumberException', message: validateFieldMessages.phone_number });
        }
      }
      if (element.type === 'email' && element.value && !this.checkIfValidEmailFormat(element.value)) {
        errorList.push({ name: 'InvalidParameterException', message: validateFieldMessages.email });
      }
      if (element.id === 'stateSelector' && element.value === 'default') {
        errorList.push({ name: 'InvalidParameterException', message: validateFieldMessages.stateSelector });
      }
      if (element.id === 'countrySelector' && element.value === 'default') {
        errorList.push({ name: 'InvalidParameterException', message: validateFieldMessages.countrySelector });
      }
    });

    if (errorList.length > 0) {
      throw 'formValidationError', errorList;
    } else {
      return form;
    }
  },
  errorHandling(errorList) {
    if (!Array.isArray(errorList)) {
      errorList = [errorList];
    }
    errorList.forEach((error) => {
      if (error.name === 'AuthError' && error.message.includes('Password')) {
        error.name = 'AuthErrorPassword';
      } else if (error.name === 'AuthError' && (error.message.includes('Username') || error.name === 'email')) {
        error.name = 'AuthErrorEmail';
      } else if ((error.name === 'AuthError' && (error.message.includes('code') || error.name === 'code')) || error.name === 'CodeMismatchException') {
        error.name = 'AuthErrorCode';
      } else if (error.name === 'UserNotFoundException') {
        error.name = 'NotAuthorizedException';
      } else if (error.name === 'InvalidParameterException') {
        if (error.message.includes('email') || error.message.includes('username')) {
          error.name = 'InvalidParameterEmailException';
        }
        if (error.message.includes('lambda')) {
          error.name = 'NotAuthorizedException';
        }
        if (error.message.includes('phone')) {
          error.name = 'InvalidParameterPhoneNumberException';
        }
        if (error.message.includes('state')) {
          error.name = 'InvalidParameterStateSelectorException';
        }
        if (error.message.includes('country')) {
          error.name = 'InvalidParameterCountrySelectorException';
        }
        if (error.message.includes('confirmationCode')) {
          error.name = 'AuthErrorCode';
        }
        if (error.message.includes('password')) {
          error.name = 'InvalidParameterPasswordException';
        }
        if (error.message.includes('confirmPassword')) {
          error.name = 'InvalidParameterPasswordException';
        }
      } else if (error.name === 'UserNotConfirmedException') {
        store.dispatch({ type: 'accounts/updateUserNotConfirmed', payload: true });
      } else if (
        error.message === 'Local storage is missing an ID Token, Please authenticate' ||
          error === 'The user is not authenticated') {
        store.dispatch({ type: 'accounts/setCustomerId', payload: null });
      } else if (error.name === 'ExpiredCodeException') {
        error.message = customMessages.expiredCodeException;
      } else if (error.name === 'EmptyErrorCode') {
        error.message = customMessages.emptyErrorCodeException;
      } else if (error.name === 'Error' || error.message === 'Network Error' || error.name === 'LimitExceededException') {
        const globalError = document.querySelector('.global-error-box');
        globalError?.classList.remove('d-none');
      }

      if (error.name === 'NotAuthorizedException') {
        if (error.message === 'User is disabled.') {
          error.name = 'NotAuthorizedDisabledException';
        }
        store.dispatch({ type: 'accounts/setCustomerId', payload: null });
      } else if (error.name === 'PasswordException') {
        error.name = 'InvalidParameterPasswordException';
      } else if (error.name === 'UsernameExistsException') {
        error.message = customMessages.usernameExistsException;
      } else if (error.name === 'AliasExistsException') {
        error.message = customMessages.aliasExistsException;
      } else if (error.name === 'AuthErrorCode') {
        error.message = customMessages.authErrorCodeException;
      }
    });

    document.querySelectorAll('.error').forEach((error) => {
      if (error.name !== 'AuthErrorPassword' && error.name !== 'InvalidParameterPasswordException' && !error.classList.contains('jsAuthErrorPasswordExtra')) error.classList.add('d-none');
    });
    document.querySelectorAll('.input-error').forEach((inputError) => {
      inputError.classList.remove('input-error');
    });
    errorList.forEach((error) => {
      document.querySelectorAll(`.error.js${error.name}Extra`).forEach((errorExceptionExtra) => {
        if (error.message !== '' && error.name !== 'AuthErrorPassword' && error.name !== 'InvalidParameterPasswordException') {
          errorExceptionExtra.innerHTML = error.message;
        }
        const errorHolderId = errorExceptionExtra.getAttribute('id');
        const errorElmContainer = errorExceptionExtra.parentElement;

        if (errorElmContainer && errorElmContainer.classList.contains('form-input')) {
          Array.from(errorElmContainer.childNodes)
            .forEach((e) => {
              if (e.nodeName === 'INPUT') {
                //  e.setAttribute('aria-invalid',true);
                e.setAttribute('aria-labelledby', errorHolderId);
                e.focus();
              } else if (e.nodeName === 'DIV') {
                Array.from(e.childNodes).forEach((e) => {
                  if (e.nodeName === 'INPUT') {
                    // e.setAttribute('aria-invalid',true);
                    e.setAttribute('aria-labelledby', errorHolderId);
                    e.focus();
                  }
                });
              }
              return false;
            });
        } else if (errorElmContainer) {
          document.getElementById('submitButton')?.setAttribute('aria-labelledby', 'authError');
        }

        errorExceptionExtra.classList.remove('d-none');
        if (error.name === 'AuthErrorPassword' || error.name === 'InvalidParameterPasswordException') {
          errorExceptionExtra.parentNode.parentNode.querySelector('.input').classList.add('input-error');
        } else if (error.name === 'AuthErrorCode' || error.name === 'EmptyErrorCode' || error.name === 'ExpiredCodeException') {
          errorExceptionExtra.parentNode.querySelector('.confirm-code').classList.add('input-error');
        } else {
          errorExceptionExtra.parentNode.querySelector('.input').classList.add('input-error');
        }
      });
    });
  },
  checkHasSpecialCharacter(str) {
    return /[\^$*.\[\]{}\(\)\?"!@#%&\/\\,><':;\|_~`]+/.test(str);
  },
  checkHasNum(str) {
    return /[0-9]+/.test(str);
  },
  checkHasLowCase(str) {
    return /[a-z]+/.test(str);
  },
  checkHasUpCase(str) {
    return /[A-Z]+/.test(str);
  },
  checkIfValidPhoneFormat(str) {
    return /^\+\d{11}$/.test(str);
  },
  checkIfValidEmailFormat(str) {
    return /^[\w\-\.]+@(?:[\w\-]{1,}\.)+[a-zA-Z]{2,}$/.test(str);
  },
});

export default FormValidator;
